import { myAxios, FETCH_HE_URL } from "./helper";
export const fetchHe = () => {
    return myAxios.get(FETCH_HE_URL)
    .then((response) => response.data); 
}

